import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiToastOutletComponent } from '@shared/ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiToastOutletComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {}
